<section class="form">

  <app-simulation-controller></app-simulation-controller>

  <mat-form-field class="form-item">
    <mat-label>Type</mat-label>
    <mat-select [formControl]="typeControl" (selectionChange)="setTypeChangeAction($event.value)">
      @for (type of types; track type) {
        <mat-option [value]="type"> {{ type }} </mat-option>
      }
    </mat-select>
    @if (typeControl.hasError('required')) {
      <mat-error>Type is Required</mat-error>
    }
  </mat-form-field>

  <app-simulation-pump-end></app-simulation-pump-end>

  <mat-form-field class="form-item">
    <mat-label>Name appendix</mat-label>
    <input matInput placeholder="Name appendix" value={{appendix}} (input)="onInput($event.target.value)">
  </mat-form-field>

  <mat-form-field class="form-item">
    <mat-label>Coefficient set name</mat-label>
    <input disabled matInput placeholder="Coefficient set name" [value]="(createSetName$ | async)">
  </mat-form-field>
</section>